// How a customer reached us, as the backend hands it over on /cases and
// /cases/{id}. Absent on a case that arrived cold, which is most of them, so
// every field here is optional at the call site.

export interface CaseReferral {
  code: string;
  partnerId?: string;
  partnerName?: string;
  partnerEmail?: string;
}

export interface CaseCoupon {
  code?: string;
  name?: string;
  percentOff?: number;
  amountOffCents?: number;
  discountCents?: number;
  currency?: string;
  /** Pre-rendered by the backend, e.g. "SUMMER20 (10% off)". */
  label?: string;
}

export interface CaseAttributionData {
  source?: 'referral' | 'coupon' | 'referral_and_coupon';
  referral?: CaseReferral;
  coupon?: CaseCoupon;
}

/** What to call the partner: their name when we resolved one, else the raw code. */
export const referralLabel = (referral: CaseReferral): string =>
  referral.partnerName || referral.code;

/** What to call the discount, falling back through the backend's own label. */
export const couponLabel = (coupon: CaseCoupon): string =>
  coupon.label || coupon.code || coupon.name || 'Discount';

/**
 * The free-text a case can be found by in the cases search. A lawyer chasing
 * "everything Lisbon Relocations sent us" or "who used SUMMER20" types the
 * name or the code, not a case id.
 */
export const attributionSearchTerms = (attribution?: CaseAttributionData): string[] => {
  if (!attribution) {
    return [];
  }
  return [
    attribution.referral?.code,
    attribution.referral?.partnerName,
    attribution.referral?.partnerEmail,
    attribution.coupon?.code,
    attribution.coupon?.name,
  ].filter((value): value is string => Boolean(value));
};
